function parseAdminDateTime(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const text = String(value).trim();
  if (!text) {
    return null;
  }

  const normalized = text.includes(" ") && !text.includes("T")
    ? text.replace(" ", "T")
    : text;

  // Naive ISO datetimes from the API are UTC.
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d+)?$/.test(normalized)) {
    return new Date(`${normalized}Z`);
  }

  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatAdminDateTime(value, emptyLabel = "-") {
  if (!value) {
    return emptyLabel;
  }

  const date = parseAdminDateTime(value);
  if (!date) {
    return value;
  }

  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function withAdminFormattedDates(item, fields) {
  const formatted = { ...item };

  fields.forEach((field) => {
    formatted[`${field}_display`] = formatAdminDateTime(item[field]);
  });

  return formatted;
}
